<template>
  <section>
    <nav-component :titulo="'Almacenes'" :link="can('almacenes.registrar') ? { path: '/agregar-almacen' } : null" :texto="'Agregar almacén'" />
    <b-breadcrumb align="is-left">
      <b-breadcrumb-item tag='router-link' to="/">Inicio</b-breadcrumb-item>
      <b-breadcrumb-item active>Almacenes</b-breadcrumb-item>
    </b-breadcrumb>

    <b-message type="is-info" v-if="almacenes.length < 1 && !cargando">
      No se han encontrado almacenes. Agrega uno pulsando el botón de Agregar almacén.
    </b-message>

    <div v-if="almacenes.length > 0">
      <b-table class="box" :data="almacenes" :paginated="isPaginated" :per-page="perPage" :current-page.sync="currentPage"
        :backend-pagination="false" :total="almacenes.length" :pagination-simple="isPaginationSimple"
        :pagination-position="paginationPosition" :default-sort-direction="defaultSortDirection"
        :pagination-rounded="isPaginationRounded" :sort-icon="sortIcon" :sort-icon-size="sortIconSize"
        default-sort="nombre" aria-next-label="Next page" aria-previous-label="Previous page"
        aria-page-label="Page" aria-current-label="Current page">
        
        <b-table-column field="cod" label="Código" sortable searchable v-slot="props">
          <span class="tag is-medium" :style="{ backgroundColor: props.row.color, color: '#fff' }">
            {{ props.row.cod }}
          </span>
        </b-table-column>

        <b-table-column field="nombre" label="Nombre" sortable searchable v-slot="props">
          {{ props.row.nombre }}
        </b-table-column>

        <b-table-column field="encargado" label="Encargado" sortable searchable v-slot="props">
          {{ props.row.encargado }}
        </b-table-column>

        <b-table-column field="color" label="Color" sortable v-slot="props">
          <div class="is-flex is-align-items-center">
            <span class="color-swatch" :style="{ backgroundColor: props.row.color }"></span>
            <span class="ml-2">{{ props.row.color }}</span>
          </div>
        </b-table-column>

        <b-table-column label="Acciones" v-slot="props" v-if="can('almacenes.editar') || can('almacenes.eliminar')">
          <b-button tag="router-link" type="is-warning" :to="{ name: 'EditarAlmacen', params: { id: props.row.id } }" v-if="can('almacenes.editar')">
            <b-icon icon="pen"></b-icon>
          </b-button>
          <b-button type="is-danger" @click="eliminar(props.row.id)" v-if="can('almacenes.eliminar')">
            <b-icon icon="delete"></b-icon>
          </b-button>
        </b-table-column>
      </b-table>
    </div>
    <b-loading :is-full-page="true" v-model="cargando" :can-cancel="false"></b-loading>
  </section>
</template>

<script>
import HttpService from '../../Servicios/HttpService'
import NavComponent from '../Extras/NavComponent.vue'

export default {
  name: "AlmacenesComponent",
  components: { NavComponent },

  data: () => ({
    cargando: false,
    almacenes: [],
    isPaginated: true,
    isPaginationSimple: false,
    isPaginationRounded: true,
    paginationPosition: 'bottom',
    defaultSortDirection: 'asc',
    sortIcon: 'arrow-up',
    sortIconSize: 'is-medium',
    currentPage: 1,
    perPage: 10,
  }),

  mounted() {
    this.obtenerDatos()
  },

  methods: {
    obtenerDatos() {
      this.cargando = true
      HttpService.obtenerConConsultas('almacenes.php', { accion: 'obtener' }).then(resultado => {
        this.almacenes = resultado
        this.cargando = false
      }).catch(() => {
        this.cargando = false
      })
    },

    eliminar(id) {
      this.$buefy.dialog.confirm({
        title: 'Eliminar almacén',
        message: '¿Estás seguro de eliminar este almacén? Los productos vinculados no se eliminarán.',
        confirmText: 'Eliminar',
        type: 'is-danger',
        hasIcon: true,
        onConfirm: () => {
          HttpService.obtenerConConsultas('almacenes.php', { accion: 'eliminar', id }).then(() => {
            this.$buefy.toast.open({ type: 'is-info', message: 'Almacén eliminado con éxito.' })
            this.obtenerDatos()
          })
        }
      })
    }
  }
}
</script>

<style scoped>
.color-swatch {
  display: inline-block;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  border: 1px solid #ddd;
}
</style>